import { render } from "./FavoriteWishlist.vue?vue&type=template&id=a09fab32"
import script from "./FavoriteWishlist.vue?vue&type=script&lang=js"
export * from "./FavoriteWishlist.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trevorwagner/Sites/Starkey/wp-content/themes/starkey-realty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__